
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 4h18v2h-2v4a7.006 7.006 0 01-3.406 6A7.004 7.004 0 0123 22v4h2v2H7v-2h2v-4a7.006 7.006 0 013.406-6A7.004 7.004 0 019 10V6H7V4zm4 2v4c0 2.774 2.226 5 5 5s5-2.226 5-5V6H11zm5 11c-2.774 0-5 2.226-5 5v4h10v-4c0-2.774-2.226-5-5-5z"}})])
          )
        }
      }
    